import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { CampaignFolderInterface } from 'app/models/campaign.model';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';

@Injectable({
  providedIn: 'root',
})
export class CampaignFolderDataTransformPost extends DataTransformAbstractPost {
  constructor(protected datePipe: DatePipe) {
    super();
  }

  transform(folder: CampaignFolderInterface): CampaignFolderInterface {
    folder.customers = (folder.customers || []).map((v) => v.id) as any;
    return folder;
  }
}
